<div class="alva-tab">
  @if (loading()) {
    <div class="spinner"><mat-spinner></mat-spinner></div>
  } @else if (error() || metrics() == undefined) {
    <div>{{ 'insemination-advice.alva.loading-error' | translate }}</div>
  } @else {
    <div class="metric-row">
      <div class="metric-title">
        {{ 'insemination-advice.alva.expected-alva-title' | translate }}
      </div>
      <div class="metric-value">
        @if (metrics()?.expectedAlvaMonths != null) {
          {{ metrics()!.expectedAlvaMonths }}
          {{ 'insemination-advice.alva.months-unit' | translate }}
        } @else {
          {{ 'insemination-advice.alva.no-information' | translate }}
        }
      </div>
    </div>

    <div class="metric-row">
      <div class="metric-title">
        {{ 'insemination-advice.alva.potential-alva-title' | translate }}
      </div>
      <div class="metric-value">
        @if (metrics()?.dairyStartAlvaMonths != null) {
          {{ metrics()!.dairyStartAlvaMonths }}
          {{ 'insemination-advice.alva.months-unit' | translate }}
        } @else {
          {{ 'insemination-advice.alva.no-information' | translate }}
        }
      </div>
    </div>

    <div class="metric-row">
      <div class="metric-title">
        {{ 'insemination-advice.alva.phosphate-title' | translate }}
      </div>
      <div class="metric-value">
        @if (metrics()?.phosphateDifferenceKg != null) {
          {{ metrics()!.phosphateDifferenceKg }}
          {{ 'insemination-advice.alva.kg-unit' | translate }}
        } @else {
          {{ 'insemination-advice.alva.no-information' | translate }}
        }
      </div>
    </div>
  }
</div>
